var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBelweBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20201107 at Sun May  6 13:46:08 2007\n By Jimmy W\xE4rting\nCopyright (c) 1988, 1991, 1995 Adobe Systems Incorporated.  All Rights Reserved.Belwe is a trademark of Esselte Pendaflex Corporation in the USA, of Letraset Canada Ltd. in Canada, and of Esselte Letraset Ltd. elsewhere.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Belwe-Bold",
    horizAdvX: 333
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Belwe",
    fontWeight: 700,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "0 0 0 0 0 0 0 0 0 0",
    ascent: 800,
    descent: -200,
    xHeight: 491,
    capHeight: 683,
    bbox: "-167 -250 1000 943",
    underlineThickness: 50,
    underlinePosition: -125,
    stemh: 60,
    stemv: 183,
    unicodeRange: "U+0020-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 268
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 268
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 268
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 370,
    d: "M227 213h-84c0 202 -65 293 -65 384c0 57 38 102 107 102s107 -45 107 -102c0 -91 -65 -182 -65 -384zM100 74c0 46 38 86 85 86s86 -40 86 -86c0 -47 -39 -85 -86 -85s-85 38 -85 85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    d: "M128 618l-20 -204c-1 -8 -10 -31 -31 -31s-30 23 -31 31l-20 204c-2 25 -6 81 51 81s53 -56 51 -81zM307 618l-20 -204c-1 -8 -10 -31 -31 -31s-30 23 -31 31l-20 204c-2 25 -6 81 51 81s53 -56 51 -81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 537,
    d: "M454 249l-3 -82h-73l-23 -167h-85l23 167h-77l-23 -167h-85l23 167h-72l3 82h81l13 96h-72l3 82h80l23 167h85l-23 -167h77l23 167h85l-23 -167h65l-3 -82h-73l-14 -96h65zM318 345h-77l-14 -96h78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 537,
    d: "M242 -82v82c-83 5 -156 40 -214 91l95 125c41 -48 119 -134 187 -134c22 0 44 20 44 43c0 85 -270 115 -270 278c0 95 40 157 158 183v76h92v-76c68 0 128 -33 175 -73l-89 -116c-34 39 -91 109 -149 109c-22 0 -45 -13 -45 -36c0 -96 282 -113 282 -286 c0 -92 -90 -180 -174 -184v-82h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 741,
    d: "M576 609l-345 -624h-60l345 624h60zM199 609c84 0 149 -67 149 -175s-65 -175 -148 -175c-84 0 -149 67 -149 175s65 175 148 175zM164 547c-25 0 -38 -17 -38 -45c0 -42 57 -181 109 -181c25 0 38 17 38 45c0 42 -57 181 -109 181zM542 335c84 0 149 -67 149 -175 s-65 -175 -148 -175c-84 0 -149 67 -149 175s65 175 148 175zM507 273c-25 0 -38 -17 -38 -45c0 -42 57 -181 109 -181c25 0 38 17 38 45c0 42 -57 181 -109 181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 778,
    d: "M398 125l-159 202c-30 -19 -36 -50 -36 -84c0 -66 60 -133 128 -133c23 0 47 4 67 15zM342 485c30 18 59 54 59 90c0 24 -11 57 -40 57c-40 0 -52 -24 -52 -62c0 -28 15 -64 33 -85zM703 357h-72c-7 -74 -11 -121 -59 -181c38 -36 66 -71 123 -71c20 0 38 8 55 16l34 -30 c-45 -63 -88 -93 -167 -93c-52 0 -101 25 -141 57c-57 -41 -126 -71 -197 -71c-130 0 -254 63 -254 209c0 101 83 179 168 220c-17 34 -30 72 -30 110c0 126 110 176 223 176c72 0 169 -37 169 -122c0 -96 -108 -120 -178 -151l136 -190c17 21 23 48 23 75 c0 35 -12 49 -43 63v61h210v-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 204,
    d: "M44 436l-11 49c24 10 56 24 60 53c-44 1 -79 36 -79 81c0 42 29 80 73 80c68 0 103 -39 103 -105c0 -83 -73 -139 -146 -158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 370,
    d: "M233 699l80 -44c-69 -119 -101 -246 -101 -383c0 -126 32 -252 97 -360l-80 -50c-118 110 -190 246 -190 410c0 177 66 307 194 427z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 370,
    d: "M137 -138l-80 44c69 119 101 246 101 383c0 126 -32 252 -97 360l80 50c118 -110 190 -246 190 -410c0 -177 -66 -307 -194 -427z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 500,
    d: "M194 683h112c-17 -46 -25 -95 -25 -145c45 20 92 42 127 78l36 -121c-44 5 -106 -7 -149 -11c29 -41 69 -72 111 -97l-96 -74c-16 51 -33 103 -60 149c-27 -46 -44 -98 -60 -149l-96 74c42 25 82 56 111 97c-43 4 -105 16 -149 11l36 121c35 -36 82 -58 127 -78 c0 50 -8 99 -25 145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 600,
    d: "M242 304v187h118v-187h184v-118h-184v-186h-118v186h-186v118h186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 268,
    d: "M76 -103l-11 49c24 10 56 24 60 53c-44 1 -79 36 -79 81c0 42 29 80 73 80c68 0 103 -39 103 -105c0 -83 -73 -139 -146 -158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    d: "M288 182h-243v127h243v-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 268,
    d: "M49 74c0 46 38 86 85 86s86 -40 86 -86c0 -47 -39 -85 -86 -85s-85 38 -85 85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 278,
    d: "M300 699l-232 -715h-90l232 715h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 537,
    d: "M333 95c32 0 53 26 53 79c0 142 -98 325 -181 325c-32 0 -53 -26 -53 -79c0 -142 98 -325 181 -325zM508 297c0 -161 -76 -312 -239 -312s-239 151 -239 312s76 312 239 312s239 -151 239 -312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 537,
    d: "M423 0h-283v60h46v388l-55 -21v63c38 15 156 74 184 104h67v-534h41v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 537,
    d: "M420 0h-335l-14 82c108 70 238 178 238 318c0 54 -32 123 -94 123c-28 0 -47 -24 -47 -49c0 -47 66 -82 86 -91l-90 -154c-57 25 -128 68 -128 158c0 140 128 222 255 222c100 0 209 -66 209 -176c0 -122 -138 -231 -224 -300l2 -1h91c31 0 58 11 64 47h57l-12 -202h-57z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 537,
    d: "M148 266l-36 41l153 155h-44c-49 0 -84 -4 -118 -44l-56 21l75 191l56 -19l-6 -17h256l31 -72l-125 -126c85 -13 146 -79 146 -166c0 -128 -110 -245 -247 -245c-87 0 -153 41 -208 84l124 124c27 -40 78 -112 132 -112c46 0 67 32 67 75c0 68 -94 116 -154 116 c-16 0 -31 -5 -46 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 537,
    d: "M242 370l-123 -165h126v165h-3zM441 130v-70h40v-60h-287v60h51v67h-208v78l291 389h113v-389l60 9l-17 -84h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 537,
    d: "M141 594h234l6 21h59l-32 -153h-211l-15 -72c36 12 72 15 110 15c97 0 174 -81 174 -177c0 -127 -94 -243 -227 -243c-80 0 -139 32 -200 81l119 134c41 -37 93 -93 153 -93c44 0 60 30 60 70c0 63 -103 97 -154 97c-26 0 -51 -10 -74 -23l-75 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 537,
    d: "M249 302c-28 0 -40 -25 -40 -48c0 -52 59 -173 129 -173c28 0 40 25 40 48c0 52 -59 173 -129 173zM470 555l-122 -120c-27 30 -50 72 -95 72c-53 0 -71 -35 -71 -101c0 -19 2 -37 3 -56c45 33 87 48 143 48c112 0 178 -98 178 -201c0 -130 -121 -212 -242 -212 c-162 0 -233 151 -233 282c0 177 112 342 302 342c50 0 100 -20 137 -54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 537,
    d: "M55 420l40 204l58 -7v-23h281l48 -91c-124 -89 -163 -364 -156 -503h-196c1 172 86 330 199 462h-136c-45 0 -63 -13 -78 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 537,
    d: "M328 91c23 0 48 15 48 41c0 45 -138 117 -171 135c-16 -13 -26 -34 -26 -55c0 -61 93 -121 149 -121zM330 372c14 16 19 30 19 51c0 49 -55 102 -103 102c-26 0 -48 -12 -48 -41c0 -47 102 -88 132 -112zM268 -15c-111 0 -217 45 -217 156c0 75 41 121 97 165 c-52 34 -74 65 -74 127c0 104 99 176 198 176c88 0 198 -48 198 -150c0 -61 -26 -85 -66 -129c52 -41 82 -72 82 -141c0 -127 -113 -204 -218 -204z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 537,
    d: "M288 292c28 0 40 25 40 48c0 52 -59 173 -129 173c-28 0 -40 -25 -40 -48c0 -52 59 -173 129 -173zM67 39l122 120c27 -30 50 -72 95 -72c53 0 71 35 71 101c0 19 -2 37 -3 56c-45 -33 -87 -48 -143 -48c-112 0 -178 98 -178 201c0 130 121 212 242 212 c162 0 233 -151 233 -282c0 -177 -112 -342 -302 -342c-50 0 -100 20 -137 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 268,
    d: "M49 315c0 46 38 86 85 86s86 -40 86 -86c0 -47 -39 -85 -86 -85s-85 38 -85 85zM49 74c0 46 38 86 85 86s86 -40 86 -86c0 -47 -39 -85 -86 -85s-85 38 -85 85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 268,
    d: "M76 -103l-11 49c24 10 56 24 60 53c-44 1 -79 36 -79 81c0 42 29 80 73 80c68 0 103 -39 103 -105c0 -83 -73 -139 -146 -158zM48 315c0 46 38 86 85 86s86 -40 86 -86c0 -47 -39 -85 -86 -85s-85 38 -85 85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 600,
    d: "M554 100v-115l-508 213v94l508 214v-115l-352 -146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 600,
    d: "M544 422v-118h-488v118h488zM544 186v-118h-488v118h488z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 600,
    d: "M46 100l352 145l-352 146v115l508 -214v-94l-508 -213v115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 519,
    d: "M290 213h-111c-1 115 25 165 53 200s55 55 55 113c0 24 -4 77 -43 77c-29 0 -41 -20 -41 -48c0 -33 13 -64 30 -91l-166 -71c-18 34 -27 73 -27 112c0 126 119 194 234 194c119 0 205 -62 205 -184c0 -74 -47 -107 -94 -143c-48 -36 -95 -75 -95 -159zM155 74 c0 46 38 86 85 86s86 -40 86 -86c0 -47 -39 -85 -86 -85s-85 38 -85 85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 800,
    d: "M502 401c0 43 -8 66 -38 66c-45 0 -113 -74 -113 -169c0 -52 21 -86 41 -86c50 0 96 54 110 189zM527 482l10 33h79l-56 -227c-2 -15 -6 -30 -6 -36c0 -25 8 -55 29 -55c43 0 95 112 95 196c0 112 -100 227 -259 227c-105 0 -252 -75 -252 -305c0 -148 135 -252 262 -252 c92 0 146 18 205 49l10 -63c-63 -36 -133 -65 -214 -65c-271 0 -389 202 -389 342c0 223 174 373 378 373c192 0 341 -130 341 -305c0 -106 -69 -247 -193 -247c-69 0 -95 59 -94 75h-2c-5 -16 -56 -72 -118 -74c-41 -1 -100 31 -100 126c0 91 65 257 205 257 c48 0 55 -26 69 -49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 704,
    d: "M376 255l-83 235h-2l-79 -235h164zM209 0h-201v78h40l207 605h191l213 -605h38v-78h-314v78h54l-30 85h-226l-30 -85h58v-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 685,
    d: "M296 358v-222c0 -50 16 -64 49 -64c87 0 97 78 97 147c0 87 -30 139 -111 139h-35zM296 605v-169c63 0 113 13 113 86c0 74 -49 83 -113 83zM80 78v527h-41v78h350c97 0 216 -22 216 -144c0 -96 -63 -123 -148 -134v-2c107 -11 191 -77 191 -191 c0 -162 -111 -212 -254 -212h-357v78h43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 667,
    d: "M551 628l31 21l47 -58l-220 -176l-41 51c15 11 24 34 24 52c0 47 -21 86 -72 86c-73 0 -86 -93 -86 -148c0 -198 98 -319 200 -319c78 0 120 31 173 84l51 -51c-80 -113 -167 -186 -312 -186c-170 0 -328 96 -328 322s170 393 371 393c64 0 113 -33 162 -71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 722,
    d: "M83 78v527h-46v78h285c212 0 361 -122 361 -340c0 -228 -139 -343 -357 -343h-294v78h51zM299 605v-527c145 0 168 155 168 269c0 133 -24 258 -168 258z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 611,
    d: "M477 447v50h72v-186h-72v44h-180v-277h32c85 0 148 17 148 100h72v-178h-514v78h46v527h-46v78h514v-142h-72v34c-37 20 -79 30 -120 30h-60v-158h180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 593,
    d: "M546 497v-188h-72v46h-173v-277h69v-78h-333v78h48v527h-48v78h509v-144h-72v34c-37 20 -79 30 -120 30h-53v-156h173v50h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 741,
    d: "M622 0l-44 67c-67 -49 -145 -83 -242 -83c-193 0 -321 130 -321 331c0 217 177 384 399 384c63 0 127 -33 178 -67l37 24l42 -63l-217 -139l-37 56c10 10 14 24 14 38c0 38 -34 56 -68 56c-128 0 -132 -161 -132 -209c0 -202 102 -283 249 -283v217h-119v78h271 c17 0 33 9 48 15l24 -49c-21 -16 -28 -27 -28 -54v-319h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 778,
    d: "M354 0h-315v78h48v527h-48v78h315v-78h-51v-158h173v158h-46v78h310v-78h-48v-527h48v-78h-310v78h46v277h-173v-277h51v-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 389,
    d: "M346 0h-303v78h42v527h-42v78h303v-78h-45v-527h45v-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 407,
    d: "M24 -2l-8 107c10 -2 22 -4 34 -4c55 0 63 39 63 86v418h-50v78h312v-78h-46v-397c0 -148 -55 -224 -210 -224c-18 0 -61 2 -95 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 722,
    d: "M354 0h-315v78h46v527h-46v78h315v-78h-53v-186l186 186h-47v78h224v-78h-44l-142 -141l200 -386h42v-78h-250l-144 310l-25 -24v-208h53v-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 556,
    d: "M446 0h-409v78h44v527h-44v78h320v-78h-60v-527h71c67 0 99 48 99 111h67l-15 -222h-73v33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 852,
    d: "M187 392l-32 -314h58v-78h-197v78h43l54 527h-50v78h240l124 -316l136 316h229v-78h-56l46 -527h44v-78h-310v78h56l-24 309h-2c-60 -122 -110 -251 -126 -387h-105c-17 137 -69 267 -126 392h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 704,
    d: "M248 0h-201v78h41v527h-41v78h228l240 -337h2v259h-51v78h199v-78h-46v-605h-130l-297 446h-2v-368h58v-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 778,
    d: "M400 699c203 0 343 -151 343 -352c0 -203 -128 -363 -365 -363c-203 0 -343 151 -343 352c0 203 128 363 365 363zM527 252c0 161 -73 352 -177 352c-68 0 -99 -34 -99 -173c0 -161 73 -352 177 -352c68 0 99 34 99 173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 704,
    d: "M364 0h-329v78h48v527h-43v78h264c180 0 365 -37 365 -256c0 -174 -125 -237 -274 -237c-33 0 -66 3 -96 9v-121h65v-78zM299 605v-285c0 -35 18 -58 64 -58c84 0 90 97 90 158c0 95 -44 185 -154 185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 778,
    d: "M738 -67l-158 -140c-102 38 -181 125 -296 125c-34 0 -67 -11 -99 -22l-47 81c50 14 82 23 113 28v2c-132 48 -216 174 -216 329c0 203 128 363 365 363c203 0 343 -151 343 -352c0 -168 -87 -306 -250 -348v-2c97 -26 169 -78 245 -64zM527 252c0 161 -73 352 -177 352 c-68 0 -99 -34 -99 -173c0 -161 73 -352 177 -352c68 0 99 34 99 173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 704,
    d: "M296 605v-301c94 0 139 59 139 152c0 97 -39 149 -139 149zM36 605v78h316c86 0 299 -31 299 -227c0 -87 -60 -159 -139 -189l112 -189h47v-78h-246l-92 230h-37v-152h48v-78h-310v78h46v527h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 648,
    d: "M542 683l63 -43l-117 -175c-57 51 -134 128 -215 128c-23 0 -55 -21 -55 -45c0 -115 388 -67 388 -336c0 -132 -146 -228 -295 -228c-112 0 -208 50 -298 113l119 169c69 -74 165 -168 273 -168c33 0 63 15 63 54c0 106 -388 89 -388 324c0 131 115 223 261 223 c59 0 122 -24 172 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 611,
    d: "M476 0h-342v78h64v513c-72 0 -94 -32 -106 -97h-72l14 205h76v-16h392v16h76l14 -205h-72c-12 65 -34 97 -106 97v-513h62v-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 778,
    d: "M490 0l-15 53c-23 -33 -104 -69 -188 -69c-149 0 -198 96 -198 230v391h-46v78h262v-472c0 -79 18 -109 84 -109s85 30 85 109v394h-44v78h260v-605h45v-78h-245z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 685,
    d: "M674 656l-228 -656h-190l-205 605h-39v78h294v-78h-36l36 -103c37 77 86 197 187 197c51 0 67 -21 109 -21c12 0 25 2 42 7zM413 194l109 320c-37 0 -72 15 -109 15c-40 0 -86 -42 -86 -82c0 -2 2 -11 6 -23l78 -230h2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1000,
    d: "M606 605l30 -93c39 77 85 187 185 187c33 0 64 -22 99 -22c11 0 22 1 33 7l33 -34l-221 -650h-184l-79 260h-2l-76 -260h-184l-193 605h-33v78h284v-78h-30l122 -401h2l64 188l-71 213h-33v78h282v-78h-28zM732 199l103 310c-35 0 -68 20 -103 20c-44 0 -77 -36 -77 -77 c0 -5 4 -18 7 -29l68 -224h2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 685,
    d: "M222 0h-206v78h37l167 290l-142 237h-34v78h338v-78h-59l95 -159l89 159h-54v78h193v-78h-41l-135 -250l160 -277h39v-78h-338v78h58l-116 197l-112 -197h61v-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 648,
    d: "M203 -14l-43 37l119 195l-243 387h-31v78h333v-78h-54l109 -186l109 186h-64v78h206v-78h-34l-276 -474l2 -2c14 12 31 17 68 18c26 1 50 -9 66 -9c21 0 33 12 56 42l46 -7l-45 -177c-29 -7 -56 -12 -86 -12c-63 0 -101 19 -152 19c-23 0 -49 -5 -86 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 574,
    d: "M123 453h-76l31 261h74v-31h344l37 -102l-301 -396c34 -9 68 -9 102 -9c57 0 118 7 137 69h69l-19 -280h-72v35h-383l-48 106l329 422c-20 5 -46 11 -98 11c-65 0 -108 -22 -126 -86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 370,
    d: "M304 -138h-238v821h238v-78h-76v-665h76v-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 278,
    d: "M-60 699h91l306 -715h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 370,
    d: "M66 -138v78h76v665h-76v78h238v-821h-238z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 600,
    d: "M189 229h-116l174 365h106l174 -365h-117l-110 248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 500,
    d: "M500 -125h-500v50h500v-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 204,
    d: "M160 699l11 -49c-24 -10 -56 -24 -60 -53c44 -1 79 -36 79 -81c0 -42 -29 -80 -73 -80c-68 0 -103 39 -103 105c0 83 73 139 146 158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 574,
    d: "M331 163v96h-29c-50 0 -86 -35 -86 -86c0 -39 11 -83 60 -83c46 0 55 35 55 73zM345 0l-11 47c-41 -35 -85 -62 -142 -62c-91 0 -159 59 -159 152c0 116 72 182 161 182h137v25c0 41 -22 66 -66 66c-58 0 -84 -42 -111 -77l-62 23l64 174l60 -20l-9 -27 c37 16 80 23 121 23c112 0 186 -48 186 -166v-280h32v-60h-201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 593,
    d: "M28 614l257 85v-62l-35 -13v-181c57 41 84 63 143 63c103 0 164 -94 164 -195c0 -211 -171 -326 -320 -326c-63 0 -125 20 -170 53v523l-39 -12v65zM250 375v-224c0 -40 22 -69 65 -69c65 0 74 72 74 122c0 61 -19 179 -101 179c-11 0 -24 -2 -38 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 500,
    d: "M440 194l43 -41c-43 -91 -124 -168 -230 -168c-140 0 -228 103 -228 239c0 160 133 282 271 282c86 0 136 -39 186 -105l-144 -136c-12 46 -46 147 -104 147c-45 0 -49 -56 -49 -89c0 -81 35 -194 132 -194c52 0 90 27 123 65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 611,
    d: "M367 117v280c-16 26 -44 41 -71 41c-70 0 -80 -72 -80 -162c0 -82 10 -167 102 -167c16 0 32 2 49 8zM367 491v73l-34 -9v60l254 84v-64l-37 -14v-561h33v-60h-199l-15 53c-34 -36 -88 -68 -139 -68c-121 0 -197 107 -197 229c0 172 103 292 232 292c34 0 70 -4 102 -15z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 537,
    d: "M203 265l129 49c-14 43 -37 116 -91 116c-39 0 -55 -31 -55 -73c0 -39 11 -65 17 -92zM481 156l38 -41c-58 -77 -138 -130 -249 -130c-151 0 -244 106 -244 265c0 139 105 256 246 256c135 0 210 -89 245 -211l-284 -104c23 -57 64 -88 126 -88c47 0 92 16 122 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 352,
    d: "M77 393h-72l37 78h50c-22 22 -30 47 -30 78c0 85 85 150 204 150c66 0 103 -19 150 -64l-116 -92c-3 23 -28 83 -55 83c-24 0 -31 -17 -31 -38c0 -61 50 -112 109 -117h29l-28 -78h-64v-333h56v-60h-283v60h44v333z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 537,
    d: "M251 443c-37 0 -52 -19 -52 -67c0 -54 31 -205 106 -205c37 0 52 19 52 67c0 54 -31 205 -106 205zM280 -20c-13 -20 -18 -44 -18 -68c0 -25 13 -52 41 -52c25 0 38 12 38 37c0 46 -26 61 -61 83zM502 580l-22 -102c-12 12 -18 20 -36 20c-12 0 -18 -11 -18 -22 c0 -20 94 -51 94 -168c0 -158 -145 -189 -266 -220v-2c83 -9 250 -27 250 -139c0 -109 -145 -135 -205 -135c-88 0 -178 19 -178 100c0 49 54 81 97 86v2c-57 5 -92 9 -134 3l-67 65c66 10 129 30 191 53v2c-86 13 -172 72 -172 177c0 144 114 206 223 206 c53 0 82 -9 110 -13l12 38c12 37 30 52 84 52c12 0 25 -2 37 -3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 648,
    d: "M297 0h-259v60h37v502l-35 -12v61l255 88v-67l-37 -13v-198c57 48 104 85 181 85c107 0 135 -77 135 -138v-308h36v-60h-257v60h38v256c0 46 -15 70 -62 70c-29 0 -54 -19 -71 -42v-284h39v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    d: "M294 0h-254v60h38v334l-36 -7v57l219 62v-446h33v-60zM72 570c0 49 65 86 108 86s89 -11 89 -63c0 -63 -79 -85 -129 -85c-40 0 -68 21 -68 62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    d: "M97 392l-38 -9v57l221 66v-403c0 -189 -58 -243 -243 -268l-12 50c54 20 72 68 72 120v387zM91 570c0 49 65 86 108 86s89 -11 89 -63c0 -63 -79 -85 -129 -85c-40 0 -68 21 -68 62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 611,
    d: "M281 0h-250v60h30v507l-30 -9v60l257 81v-62l-44 -15v-196c55 41 109 80 180 80c88 0 144 -60 144 -148c0 -93 -61 -129 -143 -152l117 -146h47v-60h-226c-8 15 -20 35 -25 42l-92 128h-2v-110h37v-60zM244 352v-146l118 79l32 -42c11 17 17 33 17 53c0 48 -34 84 -83 84 c-32 0 -60 -10 -84 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    d: "M296 0h-254v60h36v508l-34 -11v58l252 84v-62l-35 -12v-565h35v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 944,
    d: "M41 388v58l218 60v-74c50 38 100 74 166 74c59 0 106 -35 130 -88c51 44 105 88 171 88c70 0 145 -26 145 -165v-281h32v-60h-250v60h35v261c0 44 -16 65 -61 65c-22 0 -46 -19 -62 -33v-293h32v-60h-252v60h37v261c0 44 -16 65 -61 65c-22 0 -46 -19 -62 -33v-293h32 v-60h-250v60h35v335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 648,
    d: "M296 0h-257v60h35v337l-35 -10v59l220 60v-81c51 40 102 81 171 81c127 0 145 -87 145 -142v-304h34v-60h-255v60h38v282c0 29 -26 44 -53 44c-34 0 -58 -20 -82 -41v-285h39v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 630,
    d: "M315 -15c-159 0 -282 99 -282 261c0 161 123 260 282 260c160 0 283 -99 283 -260c0 -162 -123 -261 -283 -261zM284 430c-68 0 -68 -76 -68 -113c0 -72 30 -256 131 -256c54 0 68 59 68 113c0 72 -30 256 -131 256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 611,
    d: "M249 400v-258c0 -44 14 -81 62 -81c60 0 86 38 86 150c0 180 -88 189 -119 189h-29zM31 388v60l218 58v-50c45 28 80 50 126 50c115 0 205 -96 205 -239c0 -141 -86 -282 -234 -282c-30 0 -70 4 -97 20v-100h65v-60h-283v60h35v492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 611,
    d: "M371 118v233c-14 43 -26 75 -78 75c-57 0 -77 -58 -77 -107c0 -62 19 -217 100 -217c28 0 47 12 55 16zM589 -155h-280v60h62v129c-34 -28 -79 -49 -125 -49c-138 0 -213 111 -213 214c0 179 131 307 294 307c61 0 111 -30 142 -52l90 37c-2 -14 -5 -28 -5 -60v-524h35 v-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 444,
    d: "M34 391v61l201 54v-118h2c12 34 31 118 78 118c30 0 46 -6 74 -20l12 20l55 -19l-60 -169c-26 10 -52 20 -81 22c-18 0 -46 -6 -66 -37v-243h49v-60h-266v60h34v344z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 463,
    d: "M428 451l-78 -120c-29 30 -87 99 -132 99c-17 0 -31 -3 -31 -23c0 -91 250 -83 250 -247c0 -126 -109 -175 -219 -175c-72 0 -144 31 -201 71l84 128c40 -42 109 -123 170 -123c13 0 37 17 37 31c0 75 -250 99 -250 234c0 116 84 180 194 180c68 0 118 -20 176 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 370,
    d: "M69 117v296h-49v55c78 22 148 76 179 152l60 -11c-6 -25 -7 -52 -7 -78v-40h89l-15 -78h-74v-289c0 -31 26 -40 41 -40c17 0 34 7 48 16l26 -43c-50 -37 -107 -72 -172 -72c-91 0 -126 45 -126 132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 630,
    d: "M390 0l-14 53c-44 -35 -105 -68 -163 -68c-97 0 -142 46 -142 139v270l-35 -10v58l218 64v-329c0 -41 7 -78 55 -78c33 0 58 16 69 29v262l-37 -8v59l220 65v-446h33v-60h-204z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 556,
    d: "M344 193l69 174c-7 -1 -13 -4 -21 -4c-9 0 -60 16 -72 17c-11 1 -39 -2 -39 -40c0 -5 3 -15 8 -26zM31 351l-20 48l195 107l51 -134h2c16 54 42 134 110 134c56 0 99 -38 158 -15l19 -14c-10 -18 -18 -36 -26 -56l-137 -331c-12 -29 -20 -60 -28 -90h-120 c-3 9 -6 17 -10 25l-10 24l-149 318z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 833,
    d: "M621 182l69 174c-7 -1 -13 -4 -21 -4c-9 0 -60 16 -72 17c-11 1 -39 -2 -39 -40c0 -6 4 -18 11 -33zM290 399l195 107l51 -134h2c16 54 42 134 110 134c56 0 99 -38 158 -15l19 -14c-10 -18 -18 -36 -26 -56l-137 -331c-12 -29 -20 -60 -28 -90h-120c-3 9 -6 17 -10 25 l-10 24l-65 139c-29 -61 -55 -123 -76 -188h-120c-3 9 -6 17 -10 25l-10 24l-149 318l-35 -16l-20 48l195 107l140 -324l42 97l-41 88l-35 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 556,
    d: "M187 0h-172v60h39l126 196l-100 175h-30v60h271v-60h-35l58 -103l59 103h-27v60h153v-60h-32l-108 -178l115 -193h37v-60h-280v60h41l-74 119l-78 -119h37v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 574,
    d: "M350 175l69 174c-7 -1 -13 -4 -21 -4c-14 0 -60 18 -78 18c-29 0 -33 -19 -33 -37c0 -9 3 -20 9 -33zM6 390l201 116l58 -136h2c14 51 70 136 136 136c46 0 62 -21 104 -21c14 0 25 4 32 14l29 -31l-248 -567c-33 -76 -78 -120 -166 -120c-24 0 -50 4 -72 13l26 149 c27 -12 68 -27 97 -27c23 1 40 10 40 34c0 11 -9 32 -19 54l-162 350l-31 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 463,
    d: "M426 435l-236 -303c10 -1 21 -3 31 -3c72 0 127 12 164 80l58 -6l-32 -231h-59l3 28h-292l-42 87l232 291c-14 3 -29 6 -44 6c-49 0 -89 -22 -113 -65l-48 12l40 186h59l-3 -26h258z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 370,
    d: "M77 -2v172c0 62 -3 93 -58 110c55 18 58 49 58 111v172c0 116 59 136 227 136v-21c-49 -15 -65 -42 -65 -109v-164c0 -68 -11 -107 -72 -124v-2c61 -16 72 -55 72 -123v-164c0 -67 16 -94 65 -109v-21c-168 0 -227 20 -227 136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 222,
    d: "M52 -250v1000h118v-1000h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 370,
    d: "M293 170v-172c0 -116 -59 -136 -227 -136v21c49 15 65 42 65 109v164c0 68 11 107 72 123v2c-61 17 -72 56 -72 124v164c0 67 -16 94 -65 109v21c168 0 227 -20 227 -136v-172c0 -62 3 -93 58 -111c-55 -17 -58 -48 -58 -110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 600,
    d: "M495 338l36 -96c-30 -42 -63 -86 -125 -86c-37 0 -69 15 -102 33c-32 18 -69 35 -115 35c-44 0 -68 -37 -84 -72l-36 96c22 42 58 86 125 86c34 0 73 -15 111 -32c37 -16 75 -36 102 -36c40 0 65 37 88 72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 370,
    d: "M143 331h84c0 -202 65 -293 65 -384c0 -57 -38 -102 -107 -102s-107 45 -107 102c0 91 65 182 65 384zM270 470c0 -46 -38 -86 -85 -86s-86 40 -86 86c0 47 39 85 86 85s85 -38 85 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 537,
    d: "M200 517v92h92v-79c60 -7 112 -41 146 -91l-123 -113c-18 32 -42 119 -87 119c-41 0 -51 -34 -51 -69c0 -63 39 -170 115 -170c44 0 78 19 102 56l45 -41c-33 -58 -81 -114 -147 -134v-102h-92v95c-102 13 -164 98 -164 197c0 113 60 197 164 240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 537,
    d: "M222 132h137c42 0 48 11 53 51h57l-15 -208h-58v25h-307l-30 110c61 41 76 79 74 154h-67v78h43c-22 28 -33 62 -33 98c0 106 127 169 218 169c73 0 137 -36 184 -91l-139 -113c-11 30 -44 126 -83 126c-22 0 -41 -10 -41 -35c0 -38 63 -115 77 -154h110v-78h-100 c-11 -53 -39 -101 -80 -131v-1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 167,
    d: "M-167 -15l418 624h82l-419 -624h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 537,
    d: "M416 0h-269v60h37v163h-164v60h150l-43 66h-107v60h70l-87 125h-23v60h280v-60h-68l132 -190l102 190h-60v60h180v-60l-27 -1l-68 -124h65v-60h-98l-37 -66h135v-60h-136v-163h36v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 537,
    d: "M100 -67l49 321h-83l16 78h79l11 87c14 111 63 190 188 190c58 0 120 -19 157 -66l-132 -89c-7 33 1 91 -48 91c-24 0 -29 -35 -29 -52c0 -109 46 -166 98 -166h35l-13 -73h-90l-41 -257c-17 -104 -55 -189 -137 -189h-140l16 64c54 0 57 15 64 61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 500,
    d: "M175 379c-21 -16 -43 -39 -43 -66c0 -54 71 -60 110 -71c18 -5 70 -17 84 -20c17 0 42 40 42 71c0 44 -103 60 -134 69c-20 6 -40 11 -59 17zM460 685l-56 -158c-51 48 -119 94 -192 94c-28 0 -55 -12 -55 -44c0 -88 314 -18 314 -223c0 -68 -34 -115 -87 -153 c46 -26 72 -65 72 -119c0 -116 -95 -189 -205 -189c-53 0 -88 10 -134 36l-12 -43l-58 17l55 164c43 -41 132 -96 191 -96c28 0 55 9 55 40c0 89 -319 32 -319 228c0 67 44 119 93 160c-52 25 -73 60 -73 116c0 111 91 184 200 184c54 0 89 -13 141 -28l13 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 537,
    d: "M8 152l58 58c-29 33 -46 84 -46 139s15 111 46 141l-58 58l63 63l57 -57c30 26 87 44 143 44c53 0 107 -18 133 -42l58 58l68 -68l-56 -56c26 -28 43 -84 43 -139s-17 -109 -45 -143l56 -56l-60 -60l-58 58c-30 -30 -85 -48 -140 -48c-58 0 -112 17 -144 46l-57 -57z M270 212c75 0 131 64 131 139c0 73 -56 137 -130 137c-77 0 -135 -62 -135 -139c0 -76 59 -137 134 -137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 222,
    d: "M162 618l-20 -204c-1 -8 -10 -31 -31 -31s-30 23 -31 31l-20 204c-2 25 -6 81 51 81s53 -56 51 -81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 463,
    d: "M400 699l11 -49c-24 -10 -56 -24 -60 -53c44 -1 79 -36 79 -81c0 -42 -29 -80 -73 -80c-68 0 -103 39 -103 105c0 83 73 139 146 158zM178 699l11 -49c-24 -10 -56 -24 -60 -53c44 -1 79 -36 79 -81c0 -42 -29 -80 -73 -80c-68 0 -103 39 -103 105c0 83 73 139 146 158z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 481,
    d: "M241 246l105 196h95l-50 -196l52 -195h-95zM39 246l105 196h95l-50 -196l52 -195h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 278,
    d: "M38 247l107 195h95l-52 -195l50 -196h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 278,
    d: "M133 442l107 -195l-105 -196h-95l50 196l-52 195h95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "\uFB01",
    horizAdvX: 648,
    d: "M593 506v-446h33v-60h-254v60h38v333h-133v-333h56v-60h-283v60h44v333h-72l37 78h57v2c-16 11 -24 49 -24 81c0 76 74 145 219 145c57 0 151 -19 230 -89l-171 -58c-36 68 -81 74 -108 74c-24 0 -31 -17 -31 -38c0 -69 55 -117 118 -117c16 0 32 0 75 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "\uFB02",
    horizAdvX: 648,
    d: "M94 393h-73l37 78h57v2c-16 11 -23 49 -23 81c0 76 73 145 218 145c57 0 134 -22 172 -48l145 48v-58l-34 -16v-565h34v-60h-254v60h37v501l-37 -10c-20 33 -69 75 -113 75c-31 0 -40 -19 -40 -43c0 -82 79 -112 146 -112h16l-42 -78h-63v-333h55v-60h-283v60h45v333z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 500,
    d: "M0 300h500v-109h-500v109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 500,
    d: "M157 683h186c-45 -62 -46 -109 -46 -183c61 2 124 21 173 56v-193c-49 35 -112 54 -173 56c0 -73 1 -129 53 -185c-58 -112 -59 -225 -59 -349h-82c0 124 -1 237 -59 349c52 56 53 112 53 185c-61 -2 -124 -21 -173 -56v193c49 -35 112 -54 173 -56c0 74 -1 121 -46 183z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 500,
    d: "M157 683h186c-45 -59 -46 -106 -46 -168c61 2 124 21 173 56v-193c-49 35 -112 54 -177 53c0 -64 3 -104 52 -147c-49 -43 -52 -83 -52 -147c65 -1 128 18 177 53v-193c-49 35 -112 54 -173 56c0 -62 1 -109 46 -168h-186c45 59 46 106 46 168c-61 -2 -124 -21 -173 -56 v193c49 -35 112 -54 177 -53c0 64 -3 104 -52 147c49 43 52 83 52 147c-65 1 -128 -18 -177 -53v193c49 -35 112 -54 173 -56c0 62 -1 109 -46 168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 268,
    d: "M49 245c0 47 38 86 85 86s86 -39 86 -86s-39 -85 -86 -85s-85 38 -85 85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 620,
    d: "M322 636v-751h-114v419c-84 0 -140 81 -140 197c0 128 54 182 193 182h291v-24c-27 -5 -62 -6 -62 -35v-739h-114v751h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 500,
    d: "M425 342c0 -97 -78 -175 -175 -175s-175 77 -175 175c0 97 77 175 175 175c97 0 175 -78 175 -175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 204,
    d: "M44 -103l-11 49c24 10 56 24 60 53c-44 1 -79 36 -79 81c0 42 29 80 73 80c68 0 103 -39 103 -105c0 -83 -73 -139 -146 -158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 463,
    d: "M63 -103l-11 49c24 10 56 24 60 53c-44 1 -79 36 -79 81c0 42 29 80 73 80c68 0 103 -39 103 -105c0 -83 -73 -139 -146 -158zM285 -103l-11 49c24 10 56 24 60 53c-44 1 -79 36 -79 81c0 42 29 80 73 80c68 0 103 -39 103 -105c0 -83 -73 -139 -146 -158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 463,
    d: "M63 436l-11 49c24 10 56 24 60 53c-44 1 -79 36 -79 81c0 42 29 80 73 80c68 0 103 -39 103 -105c0 -83 -73 -139 -146 -158zM285 436l-11 49c24 10 56 24 60 53c-44 1 -79 36 -79 81c0 42 29 80 73 80c68 0 103 -39 103 -105c0 -83 -73 -139 -146 -158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 481,
    d: "M335 442l107 -195l-105 -196h-95l50 196l-52 195h95zM133 442l107 -195l-105 -196h-95l50 196l-52 195h95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 1000,
    d: "M81 74c0 46 38 86 85 86s86 -40 86 -86c0 -47 -39 -85 -86 -85s-85 38 -85 85zM414 74c0 46 38 86 85 86s86 -40 86 -86c0 -47 -39 -85 -86 -85s-85 38 -85 85zM747 74c0 46 38 86 85 86s86 -40 86 -86c0 -47 -39 -85 -86 -85s-85 38 -85 85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1000,
    d: "M539 609l-345 -624h-60l345 624h60zM162 609c84 0 149 -67 149 -175s-65 -175 -148 -175c-84 0 -149 67 -149 175s65 175 148 175zM127 547c-25 0 -38 -17 -38 -45c0 -42 57 -181 109 -181c25 0 38 17 38 45c0 42 -57 181 -109 181zM505 335c84 0 149 -67 149 -175 s-65 -175 -148 -175c-84 0 -149 67 -149 175s65 175 148 175zM470 273c-25 0 -38 -17 -38 -45c0 -42 57 -181 109 -181c25 0 38 17 38 45c0 42 -57 181 -109 181zM838 335c84 0 149 -67 149 -175s-65 -175 -148 -175c-84 0 -149 67 -149 175s65 175 148 175zM803 273 c-25 0 -38 -17 -38 -45c0 -42 57 -181 109 -181c25 0 38 17 38 45c0 42 -57 181 -109 181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 519,
    d: "M229 331h111c1 -115 -25 -165 -53 -200s-55 -55 -55 -113c0 -24 4 -77 43 -77c29 0 41 20 41 48c0 33 -13 64 -30 91l166 71c18 -34 27 -73 27 -112c0 -126 -119 -194 -234 -194c-119 0 -205 62 -205 184c0 74 47 107 94 143c48 36 95 75 95 159zM364 470 c0 -46 -38 -86 -85 -86s-86 40 -86 86c0 47 39 85 86 85s85 -38 85 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    d: "M287 556l-259 44l32 119l245 -95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    d: "M46 556l-18 68l245 95l32 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    d: "M339 556l-170 48l-177 -46l-19 67l197 85l189 -84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    d: "M292 707l58 -28c-31 -58 -51 -114 -126 -114c-18 0 -42 7 -65 14c-24 8 -47 17 -66 21c-28 7 -42 -28 -57 -44l-54 30c26 53 53 113 121 113c24 0 45 -8 66 -15c21 -8 43 -16 69 -16c33 0 40 12 54 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    d: "M330 578h-326v83h326v-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    d: "M-32 674l46 47c48 -48 92 -67 160 -67c60 0 105 29 152 64l38 -42c-39 -69 -111 -120 -191 -120c-90 0 -152 48 -205 118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    d: "M167 701c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    d: "M263 701c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67zM70 701c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    d: "M167 619c24 0 40 20 40 39s-16 39 -40 39s-40 -20 -40 -39s16 -39 40 -39zM55 658c0 64 50 111 112 111s112 -47 112 -111s-50 -111 -112 -111s-112 47 -112 111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    d: "M45 -204l10 61c23 -16 57 -27 85 -27c21 0 60 2 60 31s-31 32 -53 32c-19 0 -39 -5 -51 -5l34 127h54l-19 -68c53 0 123 -13 123 -81c0 -70 -65 -92 -124 -92c-41 0 -81 7 -119 22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    d: "M71 556l-72 15l89 148l107 -26zM247 556l-72 15l89 148l106 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    d: "M259 -157l16 -48c-38 -15 -78 -21 -119 -21c-59 0 -134 22 -134 92c0 71 97 108 179 134h50c-95 -46 -141 -86 -141 -118c0 -47 51 -52 72 -52c26 0 44 1 77 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    d: "M-12 710l175 -49l177 49l19 -70l-196 -84l-190 84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 1000,
    d: "M0 300h1000v-109h-1000v109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 926,
    d: "M221 272h187v333h-2zM864 497v-186h-72v44h-180v-277h32c85 0 148 17 148 100h72v-178h-502v78h46v102h-233l-59 -102h58v-78h-212v78h43l304 527h-63v78h618v-142h-72v34c-37 20 -79 30 -120 30h-60v-158h180v50h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 344,
    d: "M199 493v58h-19c-32 0 -56 -22 -56 -52c0 -24 7 -50 39 -50c30 0 36 21 36 44zM208 395l-7 28c-27 -21 -55 -37 -92 -37c-59 0 -104 35 -104 91c0 70 47 109 105 109h89v15c0 25 -14 40 -43 40c-38 0 -54 -10 -72 -31l-40 14l41 89l39 -12l-6 -16c25 9 52 14 79 14 c73 0 121 -29 121 -100v-168h21v-36h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 556,
    d: "M81 354v251h-44v78h320v-78h-60v-183l100 51v-110l-100 -53v-232h71c67 0 99 48 99 111h67l-15 -222h-73v33h-409v78h44v166l-54 -28v110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 778,
    d: "M507 403l-192 -235c30 -54 69 -89 113 -89c68 0 99 34 99 173c0 50 -7 103 -20 151zM275 268l194 237c-30 59 -71 99 -119 99c-68 0 -99 -34 -99 -173c0 -54 8 -112 24 -163zM649 725h121l-113 -138c55 -61 86 -145 86 -240c0 -203 -128 -363 -365 -363 c-66 0 -126 16 -176 45l-70 -86h-124l119 145c-58 63 -92 149 -92 248c0 203 128 363 365 363c71 0 135 -19 186 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1000,
    d: "M482 107v378c-7 39 -44 119 -128 119c-66 0 -124 -24 -124 -173c0 -95 71 -352 186 -352c36 0 60 16 66 28zM866 447v50h72v-186h-72v44h-180v-277h32c85 0 148 17 148 100h72v-178h-427v26h-2c-19 -28 -81 -42 -152 -42c-203 0 -343 151 -343 353c0 218 158 362 365 362 c60 0 115 -12 130 -34h2v18h427v-142h-72v34c-37 20 -79 30 -120 30h-60v-158h180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 378,
    d: "M189 386c-104 0 -184 59 -184 157c0 97 80 156 184 156s184 -59 184 -156c0 -98 -80 -157 -184 -157zM204 432c41 0 50 35 50 75c0 39 -28 146 -80 146c-41 0 -50 -35 -50 -75c0 -39 28 -146 80 -146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 815,
    d: "M308 163v96h-29c-50 0 -86 -35 -86 -86c0 -39 11 -83 60 -83c46 0 55 35 55 73zM481 255l129 49c-17 35 -37 116 -87 116c-44 0 -59 -36 -59 -73c0 -29 11 -65 17 -92zM133 530l60 -20l-9 -27c37 16 80 23 121 23c69 0 95 -20 121 -45c36 35 92 45 120 45 c130 0 205 -94 240 -216l-284 -104c23 -57 64 -93 126 -93c47 0 92 11 122 48l38 -41c-41 -77 -134 -115 -232 -115c-72 0 -144 24 -191 78c-61 -48 -117 -78 -196 -78c-91 0 -159 59 -159 152c0 116 72 182 161 182h137v25c0 41 -22 66 -66 66c-58 0 -84 -42 -111 -77 l-62 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    d: "M294 0h-254v60h38v334l-36 -7v57l219 62v-446h33v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    d: "M45 557v58l251 84v-62l-35 -12v-204l50 19v-78l-50 -20v-282h35v-60h-254v60h36v210l-52 -21v81l52 20v218z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 630,
    d: "M229 213l133 166c-18 28 -43 51 -78 51c-68 0 -68 -76 -68 -125c0 -32 5 -62 13 -92zM397 300l-137 -171c17 -32 45 -68 79 -68c62 0 76 59 76 113c0 42 -5 85 -18 126zM498 549h98l-84 -105c53 -43 86 -107 86 -193c0 -167 -123 -266 -288 -266c-51 0 -99 11 -139 33 l-59 -74h-98l94 118c-47 44 -75 108 -75 185c0 167 125 259 283 259c47 0 90 -8 128 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 907,
    d: "M569 260l129 49c-17 35 -37 121 -87 121c-43 0 -59 -39 -59 -78c0 -27 11 -65 17 -92zM876 295l-284 -104c23 -57 64 -93 126 -93c47 0 92 16 122 53l38 -41c-58 -77 -151 -125 -249 -125c-70 0 -126 23 -154 63c-36 -40 -105 -63 -179 -63c-159 0 -282 99 -282 261 c0 161 123 260 282 260c78 0 147 -21 192 -64c37 39 94 64 143 64c135 0 210 -89 245 -211zM265 430c-68 0 -68 -76 -68 -113c0 -72 30 -256 131 -256c54 0 68 59 68 113c0 72 -30 256 -131 256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 667,
    d: "M270 0h-218v60h35v333h-60l35 78h25v28c0 127 124 200 250 200c87 0 215 -23 215 -134c0 -44 -21 -67 -41 -86s-41 -33 -41 -58c0 -32 43 -48 86 -78c42 -30 85 -74 85 -166c0 -125 -99 -193 -194 -193c-51 0 -82 12 -110 20v173c18 -22 60 -59 90 -59c29 0 49 21 49 51 c0 41 -39 65 -78 94s-78 63 -78 120c0 39 19 68 39 96s39 55 39 93c0 37 -27 49 -61 49c-44 0 -67 -21 -67 -64v-557z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 600,
    d: "M544 186h-488v118h488v-118zM225 414c0 42 35 76 76 76c40 0 75 -35 75 -76c0 -38 -35 -75 -74 -75c-42 0 -77 34 -77 75zM225 76c0 42 35 75 76 75c40 0 75 -34 75 -75c0 -38 -35 -76 -74 -76c-42 0 -77 35 -77 76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 805,
    d: "M567 123v99h-2l-80 -99h82zM166 -15l418 624h82l-419 -624h-81zM289 600l20 -43l-81 -75c55 -8 94 -48 94 -100c0 -77 -71 -147 -160 -147c-57 0 -100 25 -135 50l80 75c18 -24 51 -67 86 -67c30 0 50 19 50 45c0 40 -67 69 -106 69c-11 0 -21 -3 -30 -3l-24 24l100 93 h-29c-32 0 -55 -2 -77 -26l-36 12l49 115l36 -11l-4 -11h167zM694 78v-42h26v-36h-187v36h34v40h-136v47l190 233h73v-233l39 5l-11 -50h-28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 805,
    d: "M565 222l-81 -99h83v99h-2zM151 -15l418 624h82l-419 -624h-81zM244 244h-184v36h30v233l-36 -13v38c24 8 101 45 120 62h43v-320h27v-36zM694 78v-42h26v-36h-187v36h34v40h-136v47l189 233h74v-233l39 5l-11 -50h-28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 322,
    d: "M260 244h-184v36h30v233l-36 -13v38c24 8 101 45 120 62h43v-320h27v-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 600,
    d: "M544 407l-161 -162l161 -161l-84 -84l-160 162l-160 -162l-84 84l161 161l-161 162l83 84l161 -162l160 162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 800,
    d: "M400 -16c-203 0 -350 153 -350 357c0 203 147 358 350 358s350 -155 350 -358c0 -204 -147 -357 -350 -357zM400 48c154 0 259 129 259 293c0 163 -105 294 -259 294s-259 -131 -259 -294c0 -164 105 -293 259 -293zM231 520v21h209c64 0 110 -32 110 -102 c0 -40 -27 -85 -76 -99l57 -85c19 -28 39 -56 58 -81v-15h-100c-30 0 -63 107 -98 167h-20v-109c0 -27 0 -35 42 -37v-21h-182v21c42 2 42 10 42 37v266c0 26 0 35 -42 37zM371 514v-161h23c43 0 49 49 49 83c0 59 -14 78 -44 78h-28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 704,
    d: "M87 78v527h-42v78h303v-78h-45v-55h20c146 0 331 -26 331 -187c0 -128 -127 -173 -274 -173c-20 0 -40 1 -77 4v-116h45v-78h-303v78h42zM303 484v-214c11 -13 34 -20 65 -20c74 0 90 57 90 107c0 62 -41 124 -155 127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 222,
    d: "M52 -175v350h118v-350h-118zM52 325v350h118v-350h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 722,
    d: "M83 78v273h-51v80h51v174h-46v78h285c212 0 361 -122 361 -340c0 -228 -139 -343 -357 -343h-294v78h51zM299 431h83v-80h-83v-273c145 0 168 155 168 269c0 133 -24 258 -168 258v-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 805,
    d: "M124 -15l418 624h82l-419 -624h-81zM481 0l-9 49c70 42 155 107 155 191c0 32 -21 74 -61 74c-18 0 -28 -15 -28 -30c0 -28 40 -49 66 -54l-58 -93c-50 15 -97 41 -97 95c0 84 84 133 166 133c65 0 136 -39 136 -105c0 -73 -90 -139 -146 -180l2 -1h59c20 0 38 7 41 28 h38l-8 -121h-37l-1 14h-218zM244 244h-184v36h30v233l-36 -13v38c24 8 101 45 120 62h43v-320h27v-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 600,
    d: "M544 186h-488v118h488v-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 500,
    d: "M482 401l-144 -136c-12 46 -46 147 -104 147c-45 0 -49 -56 -49 -89c0 -81 35 -194 132 -194c52 0 90 27 123 65l43 -41c-39 -83 -109 -154 -202 -165l-11 -41c53 0 123 -13 123 -81c0 -70 -65 -92 -124 -92c-41 0 -81 7 -119 22l10 61c23 -16 57 -27 85 -27 c21 0 60 2 60 31s-31 32 -53 32c-19 0 -39 -5 -51 -5l26 100c-125 11 -202 109 -202 236c0 160 133 282 271 282c86 0 136 -39 186 -105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 630,
    d: "M409 155c0 102 -40 234 -119 234c-52 0 -66 -41 -66 -99c0 -102 40 -234 119 -234c52 0 66 41 66 99zM313 669l122 65l32 -47l-98 -53c122 -86 216 -225 216 -369c0 -165 -100 -280 -268 -280c-155 0 -269 90 -269 238c0 146 120 237 260 237c7 0 14 0 20 -1 c-13 43 -34 83 -62 120l-112 -60l-32 47l104 56c-32 32 -72 57 -115 72l13 33c64 -5 129 -25 189 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 600,
    d: "M242 382v109h118v-109h184v-118h-184v-109h-118v109h-186v118h186zM56 0v118h488v-118h-488z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 667,
    d: "M629 591l-220 -176l-41 51c15 11 24 34 24 52c0 47 -21 86 -72 86c-73 0 -86 -93 -86 -148c0 -198 98 -319 200 -319c78 0 120 31 173 84l51 -51c-74 -104 -154 -175 -279 -184l-11 -39c53 0 123 -13 123 -81c0 -70 -65 -92 -124 -92c-41 0 -81 7 -119 22l10 61 c23 -16 57 -27 85 -27c21 0 60 2 60 31s-31 32 -53 32c-19 0 -39 -5 -51 -5l26 98c-163 7 -307 104 -307 320c0 226 170 393 371 393c64 0 113 -33 162 -71l31 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 611,
    d: "M314 -155h-283v60h35v656l-35 -11v65l257 84v-61l-39 -14v-168c45 28 80 50 126 50c115 0 205 -96 205 -239c0 -141 -86 -282 -234 -282c-30 0 -70 4 -97 20v-100h65v-60zM249 400v-258c0 -44 14 -81 62 -81c60 0 86 38 86 150c0 180 -88 189 -119 189h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 800,
    d: "M400 -16c-203 0 -350 153 -350 357c0 203 147 358 350 358s350 -155 350 -358c0 -204 -147 -357 -350 -357zM400 48c154 0 259 129 259 293c0 163 -105 294 -259 294s-259 -131 -259 -294c0 -164 105 -293 259 -293zM546 268h24l-15 -78c-2 -11 -13 -14 -31 -21 c-15 -5 -60 -21 -105 -21c-139 0 -219 74 -219 205c0 86 46 200 228 200c50 0 76 -10 102 -19c16 -5 23 -13 23 -22v-72h-24c-15 41 -43 86 -98 86c-68 0 -97 -66 -98 -167c-1 -102 18 -184 95 -184c49 0 91 36 118 93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 600,
    d: "M426 110v194h-370v118h488v-312h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 322,
    d: "M260 244h-218l-9 49c70 42 155 107 155 191c0 32 -21 74 -61 74c-15 0 -38 -13 -38 -30c0 -29 54 -50 66 -54l-58 -93c-40 15 -87 41 -87 95c0 84 84 133 166 133c65 0 136 -39 136 -105c0 -73 -90 -139 -146 -180l2 -1h59c20 0 38 7 41 28h38l-8 -121h-37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 322,
    d: "M296 557l-81 -75c55 -8 94 -48 94 -100c0 -77 -71 -147 -160 -147c-57 0 -100 25 -135 50l80 75c18 -24 51 -67 86 -67c30 0 50 19 50 45c0 40 -67 69 -106 69c-11 0 -21 -3 -30 -3l-24 24l100 93h-29c-32 0 -55 -2 -77 -26l-36 12l49 115l36 -11l-4 -11h167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 1000,
    d: "M259 656v-310c0 -29 0 -38 51 -40v-27h-224v27c51 2 51 11 51 40v310h-42c-38 0 -56 -29 -62 -61h-27v88h384v-88h-27c-6 32 -24 61 -62 61h-42zM663 280l-128 274h-2v-174c0 -57 0 -72 51 -74v-27h-135v27c50 2 50 17 50 74v222c-16 34 -41 54 -72 54v27h163l127 -263 l138 263h139v-27c-51 -2 -51 -11 -51 -40v-270c0 -29 0 -38 51 -40v-27h-224v27c51 2 51 11 51 40v208h-2l-140 -274h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 400,
    d: "M200 548c-51 0 -78 -33 -78 -82s27 -82 78 -82s78 33 78 82s-27 82 -78 82zM200 609c80 0 143 -63 143 -143s-63 -143 -143 -143s-143 63 -143 143s63 143 143 143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 630,
    d: "M561 506v-446h33v-60h-204l-14 53c-37 -46 -71 -65 -122 -68v-140h-218v60h35v489l-35 -10v58l218 64v-329c0 -41 7 -78 55 -78c33 0 58 16 69 29v262l-37 -8v59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 704,
    d: "M376 255l-83 235h-2l-79 -235h164zM209 0h-201v78h40l207 605h191l213 -605h38v-78h-314v78h54l-30 85h-226l-30 -85h58v-78zM232 730l-18 68l245 95l32 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 704,
    d: "M376 255l-83 235h-2l-79 -235h164zM209 0h-201v78h40l207 605h191l213 -605h38v-78h-314v78h54l-30 85h-226l-30 -85h58v-78zM525 730l-170 48l-177 -46l-19 67l197 85l189 -84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 704,
    d: "M376 255l-83 235h-2l-79 -235h164zM209 0h-201v78h40l207 605h191l213 -605h38v-78h-314v78h54l-30 85h-226l-30 -85h58v-78zM449 875c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67zM256 875c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67 c-39 0 -67 29 -67 67s29 67 67 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 704,
    d: "M376 255l-83 235h-2l-79 -235h164zM209 0h-201v78h40l207 605h191l213 -605h38v-78h-314v78h54l-30 85h-226l-30 -85h58v-78zM473 730l-259 44l32 119l245 -95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 704,
    d: "M376 255l-83 235h-2l-79 -235h164zM209 0h-201v78h40l207 605h191l213 -605h38v-78h-314v78h54l-30 85h-226l-30 -85h58v-78zM353 793c24 0 40 20 40 39s-16 39 -40 39s-40 -20 -40 -39s16 -39 40 -39zM241 832c0 64 50 111 112 111s112 -47 112 -111s-50 -111 -112 -111 s-112 47 -112 111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 704,
    d: "M376 255l-83 235h-2l-79 -235h164zM209 0h-201v78h40l207 605h191l213 -605h38v-78h-314v78h54l-30 85h-226l-30 -85h58v-78zM478 881l58 -28c-31 -58 -51 -114 -126 -114c-18 0 -42 7 -65 14c-24 8 -47 17 -66 21c-28 7 -42 -28 -57 -44l-54 30c26 53 53 113 121 113 c24 0 45 -8 66 -15c21 -8 43 -16 69 -16c33 0 40 12 54 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 611,
    d: "M477 447v50h72v-186h-72v44h-180v-277h32c85 0 148 17 148 100h72v-178h-514v78h46v527h-46v78h514v-142h-72v34c-37 20 -79 30 -120 30h-60v-158h180zM185 730l-18 68l245 95l32 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 611,
    d: "M477 447v50h72v-186h-72v44h-180v-277h32c85 0 148 17 148 100h72v-178h-514v78h46v527h-46v78h514v-142h-72v34c-37 20 -79 30 -120 30h-60v-158h180zM478 730l-170 48l-177 -46l-19 67l197 85l189 -84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 611,
    d: "M477 447v50h72v-186h-72v44h-180v-277h32c85 0 148 17 148 100h72v-178h-514v78h46v527h-46v78h514v-142h-72v34c-37 20 -79 30 -120 30h-60v-158h180zM402 875c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67zM209 875c37 0 67 -30 67 -67 c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 611,
    d: "M477 447v50h72v-186h-72v44h-180v-277h32c85 0 148 17 148 100h72v-178h-514v78h46v527h-46v78h514v-142h-72v34c-37 20 -79 30 -120 30h-60v-158h180zM426 730l-259 44l32 119l245 -95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 389,
    d: "M346 0h-303v78h42v527h-42v78h303v-78h-45v-527h45v-78zM74 730l-18 68l245 95l32 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 389,
    d: "M346 0h-303v78h42v527h-42v78h303v-78h-45v-527h45v-78zM367 730l-170 48l-177 -46l-19 67l197 85l189 -84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 389,
    d: "M346 0h-303v78h42v527h-42v78h303v-78h-45v-527h45v-78zM291 875c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67zM98 875c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 389,
    d: "M346 0h-303v78h42v527h-42v78h303v-78h-45v-527h45v-78zM315 730l-259 44l32 119l245 -95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 704,
    d: "M248 0h-201v78h41v527h-41v78h228l240 -337h2v259h-51v78h199v-78h-46v-605h-130l-297 446h-2v-368h58v-78zM478 881l58 -28c-31 -58 -51 -114 -126 -114c-18 0 -42 7 -65 14c-24 8 -47 17 -66 21c-28 7 -42 -28 -57 -44l-54 30c26 53 53 113 121 113c24 0 45 -8 66 -15 c21 -8 43 -16 69 -16c33 0 40 12 54 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 778,
    d: "M400 699c203 0 343 -151 343 -352c0 -203 -128 -363 -365 -363c-203 0 -343 151 -343 352c0 203 128 363 365 363zM527 252c0 161 -73 352 -177 352c-68 0 -99 -34 -99 -173c0 -161 73 -352 177 -352c68 0 99 34 99 173zM269 730l-18 68l245 95l32 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 778,
    d: "M400 699c203 0 343 -151 343 -352c0 -203 -128 -363 -365 -363c-203 0 -343 151 -343 352c0 203 128 363 365 363zM527 252c0 161 -73 352 -177 352c-68 0 -99 -34 -99 -173c0 -161 73 -352 177 -352c68 0 99 34 99 173zM562 730l-170 48l-177 -46l-19 67l197 85l189 -84 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 778,
    d: "M400 699c203 0 343 -151 343 -352c0 -203 -128 -363 -365 -363c-203 0 -343 151 -343 352c0 203 128 363 365 363zM527 252c0 161 -73 352 -177 352c-68 0 -99 -34 -99 -173c0 -161 73 -352 177 -352c68 0 99 34 99 173zM486 875c37 0 67 -30 67 -67 c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67zM293 875c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 778,
    d: "M400 699c203 0 343 -151 343 -352c0 -203 -128 -363 -365 -363c-203 0 -343 151 -343 352c0 203 128 363 365 363zM527 252c0 161 -73 352 -177 352c-68 0 -99 -34 -99 -173c0 -161 73 -352 177 -352c68 0 99 34 99 173zM510 730l-259 44l32 119l245 -95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 778,
    d: "M400 699c203 0 343 -151 343 -352c0 -203 -128 -363 -365 -363c-203 0 -343 151 -343 352c0 203 128 363 365 363zM527 252c0 161 -73 352 -177 352c-68 0 -99 -34 -99 -173c0 -161 73 -352 177 -352c68 0 99 34 99 173zM515 881l58 -28c-31 -58 -51 -114 -126 -114 c-18 0 -42 7 -65 14c-24 8 -47 17 -66 21c-28 7 -42 -28 -57 -44l-54 30c26 53 53 113 121 113c24 0 45 -8 66 -15c21 -8 43 -16 69 -16c33 0 40 12 54 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 648,
    d: "M542 683l63 -43l-117 -175c-57 51 -134 128 -215 128c-23 0 -55 -21 -55 -45c0 -115 388 -67 388 -336c0 -132 -146 -228 -295 -228c-112 0 -208 50 -298 113l119 169c69 -74 165 -168 273 -168c33 0 63 15 63 54c0 106 -388 89 -388 324c0 131 115 223 261 223 c59 0 122 -24 172 -55zM146 884l175 -49l177 49l19 -70l-196 -84l-190 84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 778,
    d: "M490 0l-15 53c-23 -33 -104 -69 -188 -69c-149 0 -198 96 -198 230v391h-46v78h262v-472c0 -79 18 -109 84 -109s85 30 85 109v394h-44v78h260v-605h45v-78h-245zM281 730l-18 68l245 95l32 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 778,
    d: "M490 0l-15 53c-23 -33 -104 -69 -188 -69c-149 0 -198 96 -198 230v391h-46v78h262v-472c0 -79 18 -109 84 -109s85 30 85 109v394h-44v78h260v-605h45v-78h-245zM574 730l-170 48l-177 -46l-19 67l197 85l189 -84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 778,
    d: "M490 0l-15 53c-23 -33 -104 -69 -188 -69c-149 0 -198 96 -198 230v391h-46v78h262v-472c0 -79 18 -109 84 -109s85 30 85 109v394h-44v78h260v-605h45v-78h-245zM498 875c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67zM305 875 c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 778,
    d: "M490 0l-15 53c-23 -33 -104 -69 -188 -69c-149 0 -198 96 -198 230v391h-46v78h262v-472c0 -79 18 -109 84 -109s85 30 85 109v394h-44v78h260v-605h45v-78h-245zM522 730l-259 44l32 119l245 -95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 648,
    d: "M203 -14l-43 37l119 195l-243 387h-31v78h333v-78h-54l109 -186l109 186h-64v78h206v-78h-34l-276 -474l2 -2c14 12 31 17 68 18c26 1 50 -9 66 -9c21 0 33 12 56 42l46 -7l-45 -177c-29 -7 -56 -12 -86 -12c-63 0 -101 19 -152 19c-23 0 -49 -5 -86 -17zM204 730l-18 68 l245 95l32 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 648,
    d: "M203 -14l-43 37l119 195l-243 387h-31v78h333v-78h-54l109 -186l109 186h-64v78h206v-78h-34l-276 -474l2 -2c14 12 31 17 68 18c26 1 50 -9 66 -9c21 0 33 12 56 42l46 -7l-45 -177c-29 -7 -56 -12 -86 -12c-63 0 -101 19 -152 19c-23 0 -49 -5 -86 -17zM421 875 c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67zM228 875c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 574,
    d: "M123 453h-76l31 261h74v-31h344l37 -102l-301 -396c34 -9 68 -9 102 -9c57 0 118 7 137 69h69l-19 -280h-72v35h-383l-48 106l329 422c-20 5 -46 11 -98 11c-65 0 -108 -22 -126 -86zM109 884l175 -49l177 49l19 -70l-196 -84l-190 84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 574,
    d: "M331 163v96h-29c-50 0 -86 -35 -86 -86c0 -39 11 -83 60 -83c46 0 55 35 55 73zM345 0l-11 47c-41 -35 -85 -62 -142 -62c-91 0 -159 59 -159 152c0 116 72 182 161 182h137v25c0 41 -22 66 -66 66c-58 0 -84 -42 -111 -77l-62 23l64 174l60 -20l-9 -27 c37 16 80 23 121 23c112 0 186 -48 186 -166v-280h32v-60h-201zM179 556l-18 68l245 95l32 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 574,
    d: "M331 163v96h-29c-50 0 -86 -35 -86 -86c0 -39 11 -83 60 -83c46 0 55 35 55 73zM345 0l-11 47c-41 -35 -85 -62 -142 -62c-91 0 -159 59 -159 152c0 116 72 182 161 182h137v25c0 41 -22 66 -66 66c-58 0 -84 -42 -111 -77l-62 23l64 174l60 -20l-9 -27 c37 16 80 23 121 23c112 0 186 -48 186 -166v-280h32v-60h-201zM472 556l-170 48l-177 -46l-19 67l197 85l189 -84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 574,
    d: "M331 163v96h-29c-50 0 -86 -35 -86 -86c0 -39 11 -83 60 -83c46 0 55 35 55 73zM345 0l-11 47c-41 -35 -85 -62 -142 -62c-91 0 -159 59 -159 152c0 116 72 182 161 182h137v25c0 41 -22 66 -66 66c-58 0 -84 -42 -111 -77l-62 23l64 174l60 -20l-9 -27 c37 16 80 23 121 23c112 0 186 -48 186 -166v-280h32v-60h-201zM396 701c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67zM203 701c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 574,
    d: "M331 163v96h-29c-50 0 -86 -35 -86 -86c0 -39 11 -83 60 -83c46 0 55 35 55 73zM345 0l-11 47c-41 -35 -85 -62 -142 -62c-91 0 -159 59 -159 152c0 116 72 182 161 182h137v25c0 41 -22 66 -66 66c-58 0 -84 -42 -111 -77l-62 23l64 174l60 -20l-9 -27 c37 16 80 23 121 23c112 0 186 -48 186 -166v-280h32v-60h-201zM420 556l-259 44l32 119l245 -95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 574,
    d: "M331 163v96h-29c-50 0 -86 -35 -86 -86c0 -39 11 -83 60 -83c46 0 55 35 55 73zM345 0l-11 47c-41 -35 -85 -62 -142 -62c-91 0 -159 59 -159 152c0 116 72 182 161 182h137v25c0 41 -22 66 -66 66c-58 0 -84 -42 -111 -77l-62 23l64 174l60 -20l-9 -27 c37 16 80 23 121 23c112 0 186 -48 186 -166v-280h32v-60h-201zM300 619c24 0 40 20 40 39s-16 39 -40 39s-40 -20 -40 -39s16 -39 40 -39zM188 658c0 64 50 111 112 111s112 -47 112 -111s-50 -111 -112 -111s-112 47 -112 111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 574,
    d: "M331 163v96h-29c-50 0 -86 -35 -86 -86c0 -39 11 -83 60 -83c46 0 55 35 55 73zM345 0l-11 47c-41 -35 -85 -62 -142 -62c-91 0 -159 59 -159 152c0 116 72 182 161 182h137v25c0 41 -22 66 -66 66c-58 0 -84 -42 -111 -77l-62 23l64 174l60 -20l-9 -27 c37 16 80 23 121 23c112 0 186 -48 186 -166v-280h32v-60h-201zM425 707l58 -28c-31 -58 -51 -114 -126 -114c-18 0 -42 7 -65 14c-24 8 -47 17 -66 21c-28 7 -42 -28 -57 -44l-54 30c26 53 53 113 121 113c24 0 45 -8 66 -15c21 -8 43 -16 69 -16c33 0 40 12 54 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 537,
    d: "M203 265l129 49c-14 43 -37 116 -91 116c-39 0 -55 -31 -55 -73c0 -39 11 -65 17 -92zM481 156l38 -41c-58 -77 -138 -130 -249 -130c-151 0 -244 106 -244 265c0 139 105 256 246 256c135 0 210 -89 245 -211l-284 -104c23 -57 64 -88 126 -88c47 0 92 16 122 53z M154 556l-18 68l245 95l32 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 537,
    d: "M203 265l129 49c-14 43 -37 116 -91 116c-39 0 -55 -31 -55 -73c0 -39 11 -65 17 -92zM481 156l38 -41c-58 -77 -138 -130 -249 -130c-151 0 -244 106 -244 265c0 139 105 256 246 256c135 0 210 -89 245 -211l-284 -104c23 -57 64 -88 126 -88c47 0 92 16 122 53z M447 556l-170 48l-177 -46l-19 67l197 85l189 -84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 537,
    d: "M203 265l129 49c-14 43 -37 116 -91 116c-39 0 -55 -31 -55 -73c0 -39 11 -65 17 -92zM481 156l38 -41c-58 -77 -138 -130 -249 -130c-151 0 -244 106 -244 265c0 139 105 256 246 256c135 0 210 -89 245 -211l-284 -104c23 -57 64 -88 126 -88c47 0 92 16 122 53z M371 701c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67zM178 701c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 537,
    d: "M203 265l129 49c-14 43 -37 116 -91 116c-39 0 -55 -31 -55 -73c0 -39 11 -65 17 -92zM481 156l38 -41c-58 -77 -138 -130 -249 -130c-151 0 -244 106 -244 265c0 139 105 256 246 256c135 0 210 -89 245 -211l-284 -104c23 -57 64 -88 126 -88c47 0 92 16 122 53z M395 556l-259 44l32 119l245 -95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    d: "M294 0h-254v60h38v334l-36 -7v57l219 62v-446h33v-60zM46 556l-18 68l245 95l32 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    d: "M294 0h-254v60h38v334l-36 -7v57l219 62v-446h33v-60zM339 556l-170 48l-177 -46l-19 67l197 85l189 -84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    d: "M294 0h-254v60h38v334l-36 -7v57l219 62v-446h33v-60zM263 701c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67zM70 701c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    d: "M294 0h-254v60h38v334l-36 -7v57l219 62v-446h33v-60zM287 556l-259 44l32 119l245 -95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 648,
    d: "M296 0h-257v60h35v337l-35 -10v59l220 60v-81c51 40 102 81 171 81c127 0 145 -87 145 -142v-304h34v-60h-255v60h38v282c0 29 -26 44 -53 44c-34 0 -58 -20 -82 -41v-285h39v-60zM450 707l58 -28c-31 -58 -51 -114 -126 -114c-18 0 -42 7 -65 14c-24 8 -47 17 -66 21 c-28 7 -42 -28 -57 -44l-54 30c26 53 53 113 121 113c24 0 45 -8 66 -15c21 -8 43 -16 69 -16c33 0 40 12 54 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 630,
    d: "M315 -15c-159 0 -282 99 -282 261c0 161 123 260 282 260c160 0 283 -99 283 -260c0 -162 -123 -261 -283 -261zM284 430c-68 0 -68 -76 -68 -113c0 -72 30 -256 131 -256c54 0 68 59 68 113c0 72 -30 256 -131 256zM195 556l-18 68l245 95l32 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 630,
    d: "M315 -15c-159 0 -282 99 -282 261c0 161 123 260 282 260c160 0 283 -99 283 -260c0 -162 -123 -261 -283 -261zM284 430c-68 0 -68 -76 -68 -113c0 -72 30 -256 131 -256c54 0 68 59 68 113c0 72 -30 256 -131 256zM488 556l-170 48l-177 -46l-19 67l197 85l189 -84z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 630,
    d: "M315 -15c-159 0 -282 99 -282 261c0 161 123 260 282 260c160 0 283 -99 283 -260c0 -162 -123 -261 -283 -261zM284 430c-68 0 -68 -76 -68 -113c0 -72 30 -256 131 -256c54 0 68 59 68 113c0 72 -30 256 -131 256zM412 701c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67 c-39 0 -67 29 -67 67s29 67 67 67zM219 701c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 630,
    d: "M315 -15c-159 0 -282 99 -282 261c0 161 123 260 282 260c160 0 283 -99 283 -260c0 -162 -123 -261 -283 -261zM284 430c-68 0 -68 -76 -68 -113c0 -72 30 -256 131 -256c54 0 68 59 68 113c0 72 -30 256 -131 256zM436 556l-259 44l32 119l245 -95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 630,
    d: "M315 -15c-159 0 -282 99 -282 261c0 161 123 260 282 260c160 0 283 -99 283 -260c0 -162 -123 -261 -283 -261zM284 430c-68 0 -68 -76 -68 -113c0 -72 30 -256 131 -256c54 0 68 59 68 113c0 72 -30 256 -131 256zM441 707l58 -28c-31 -58 -51 -114 -126 -114 c-18 0 -42 7 -65 14c-24 8 -47 17 -66 21c-28 7 -42 -28 -57 -44l-54 30c26 53 53 113 121 113c24 0 45 -8 66 -15c21 -8 43 -16 69 -16c33 0 40 12 54 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 463,
    d: "M428 451l-78 -120c-29 30 -87 99 -132 99c-17 0 -31 -3 -31 -23c0 -91 250 -83 250 -247c0 -126 -109 -175 -219 -175c-72 0 -144 31 -201 71l84 128c40 -42 109 -123 170 -123c13 0 37 17 37 31c0 75 -250 99 -250 234c0 116 84 180 194 180c68 0 118 -20 176 -55z M53 710l175 -49l177 49l19 -70l-196 -84l-190 84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 630,
    d: "M390 0l-14 53c-44 -35 -105 -68 -163 -68c-97 0 -142 46 -142 139v270l-35 -10v58l218 64v-329c0 -41 7 -78 55 -78c33 0 58 16 69 29v262l-37 -8v59l220 65v-446h33v-60h-204zM195 556l-18 68l245 95l32 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 630,
    d: "M390 0l-14 53c-44 -35 -105 -68 -163 -68c-97 0 -142 46 -142 139v270l-35 -10v58l218 64v-329c0 -41 7 -78 55 -78c33 0 58 16 69 29v262l-37 -8v59l220 65v-446h33v-60h-204zM488 556l-170 48l-177 -46l-19 67l197 85l189 -84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 630,
    d: "M390 0l-14 53c-44 -35 -105 -68 -163 -68c-97 0 -142 46 -142 139v270l-35 -10v58l218 64v-329c0 -41 7 -78 55 -78c33 0 58 16 69 29v262l-37 -8v59l220 65v-446h33v-60h-204zM412 701c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67z M219 701c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 630,
    d: "M390 0l-14 53c-44 -35 -105 -68 -163 -68c-97 0 -142 46 -142 139v270l-35 -10v58l218 64v-329c0 -41 7 -78 55 -78c33 0 58 16 69 29v262l-37 -8v59l220 65v-446h33v-60h-204zM436 556l-259 44l32 119l245 -95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 574,
    d: "M350 175l69 174c-7 -1 -13 -4 -21 -4c-14 0 -60 18 -78 18c-29 0 -33 -19 -33 -37c0 -9 3 -20 9 -33zM6 390l201 116l58 -136h2c14 51 70 136 136 136c46 0 62 -21 104 -21c14 0 25 4 32 14l29 -31l-248 -567c-33 -76 -78 -120 -166 -120c-24 0 -50 4 -72 13l26 149 c27 -12 68 -27 97 -27c23 1 40 10 40 34c0 11 -9 32 -19 54l-162 350l-31 -22zM167 556l-18 68l245 95l32 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 574,
    d: "M350 175l69 174c-7 -1 -13 -4 -21 -4c-14 0 -60 18 -78 18c-29 0 -33 -19 -33 -37c0 -9 3 -20 9 -33zM6 390l201 116l58 -136h2c14 51 70 136 136 136c46 0 62 -21 104 -21c14 0 25 4 32 14l29 -31l-248 -567c-33 -76 -78 -120 -166 -120c-24 0 -50 4 -72 13l26 149 c27 -12 68 -27 97 -27c23 1 40 10 40 34c0 11 -9 32 -19 54l-162 350l-31 -22zM384 701c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67zM191 701c37 0 67 -30 67 -67c0 -38 -30 -67 -67 -67c-39 0 -67 29 -67 67s29 67 67 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 463,
    d: "M426 435l-236 -303c10 -1 21 -3 31 -3c72 0 127 12 164 80l58 -6l-32 -231h-59l3 28h-292l-42 87l232 291c-14 3 -29 6 -44 6c-49 0 -89 -22 -113 -65l-48 12l40 186h59l-3 -26h258zM53 710l175 -49l177 49l19 -70l-196 -84l-190 84z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "s",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u2019",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "y",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "w",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "v",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Y",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "W",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "T",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2019",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "y",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Y",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "W",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "T",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2019",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "Y",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "W",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "y",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "w",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "u",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "s",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "r",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "o",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "i",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "e",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "c",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "a",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "A",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ";",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ":",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ".",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "-",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ",",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "y",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "i",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "e",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ";",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ":",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "u",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "r",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "o",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "i",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "e",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "a",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "A",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ";",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ":",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ".",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "-",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ",",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "v",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "u",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "o",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "i",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "e",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "a",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "A",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ";",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ":",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "-",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ",",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u2018",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ".",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "-",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ",",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ",",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ".",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ",",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ",",
    k: 55
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelweBold);
export default __webpack_public_path__ + "static/media/Belwe-Bold.eb9a53984a23ead02a8031805ca6dc65.svg";
export { ForwardRef as ReactComponent };